import mitt, * as MITT from 'mitt';
export const EventBus: MITT.Emitter = mitt();
